module.exports = __webpack_public_path__ + "img/feature-shansuan.33be87c0.jpg";